"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultCountersReq = exports.DATE_FORMAT = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
exports.DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';
exports.DefaultCountersReq = {
    LIVE: {
        live: true,
        statuses: [
            'TRADING',
            'OPEN',
            'PLANNING',
            'SUSPENDED',
        ],
        scheduledTo: (0, dayjs_1.default)().format(exports.DATE_FORMAT),
    },
    LINE: {
        live: false,
        statuses: [
            'TRADING',
            'OPEN',
            'PLANNING',
            'SUSPENDED',
        ],
        scheduledFrom: (0, dayjs_1.default)().format(exports.DATE_FORMAT),
    },
    CALENDAR: {
        statuses: ['PLANNING'],
        scheduledFrom: (0, dayjs_1.default)().format(exports.DATE_FORMAT),
    },
    RESULTS: {
        statuses: [
            'TRADING',
            'SUSPENDED',
            'OPEN',
            'CANCELLED',
            'INTERRUPTED',
            'POSTPONED',
            'ENDED',
            'CLOSED',
        ],
    },
};
//# sourceMappingURL=constants.js.map